import axios from "utils/axios";

export const checkApp = (app) => {
  return axios.get(`/app/connects/check/${app}`);
};

export const appConnect = (app) => {
  return axios.post(`/app/connects/${app}`, {}, { timeout: 180000 });
};
